/**
 * Version configuration for TEVV Pipeline Client
 */

// Version info - this will be updated during build
export const VERSION = "1.06";
export const BUILD_TIME = import.meta.env.VITE_BUILD_TIME || "unknown";
export const BUILD_HASH = import.meta.env.VITE_BUILD_HASH || "local-dev";
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";
export const ENVIRONMENT = import.meta.env.NODE_ENV || "development";

export const getVersionInfo = () => {
  return {
    version: VERSION,
    build_time: BUILD_TIME,
    commit_hash: BUILD_HASH,
    api_url: API_URL,
    environment: ENVIRONMENT,
    client_name: "TEVV Pipeline Client",
    timestamp: new Date().toISOString()
  };
};

export const logVersionInfo = () => {
  const info = getVersionInfo();
  console.log(`🚀 ${info.client_name} v${info.version}`);
  console.log(`   Environment: ${info.environment}`);
  console.log(`   Build Time: ${info.build_time}`);
  console.log(`   Commit: ${info.commit_hash}`);
  console.log(`   API URL: ${info.api_url}`);
  console.log(`   Loaded: ${info.timestamp}`);
  
  // Make version info globally available for debugging
  window.TEVV_VERSION = info;
};

export const displayVersionWatermark = () => {
  const info = getVersionInfo();
  
  // Add version info to console
  console.log(`%c🌊 TEVV Pipeline Client v${info.version}`, 
    'color: #2563eb; font-weight: bold; font-size: 14px;');
  console.log(`%cBuild: ${info.commit_hash} | ${info.build_time}`, 
    'color: #64748b; font-size: 12px;');
  console.log(`%cEnvironment: ${info.environment} | API: ${info.api_url}`, 
    'color: #64748b; font-size: 12px;');
    
  // Add to window for debugging
  window.wsManager?.resetDocumentCount && console.log('🔧 Debug tools available:');
  window.wsManager?.resetDocumentCount && console.log('  - window.wsManager (WebSocket management)');
  console.log('  - window.TEVV_VERSION (version info)');
};